module.exports = __webpack_public_path__ + "img/commitment-download-icon.6cebd38c.svg";